import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-5" }, "Bạn có chắc muốn xoá dữ liệu này?", -1)
const _hoisted_2 = { class: "text-center mb-5" }
const _hoisted_3 = { class: "overflow-x-auto" }
const _hoisted_4 = { class: "whitespace-nowrap m-0" }
const _hoisted_5 = {
  key: 0,
  class: "whitespace-nowrap m-0"
}
const _hoisted_6 = { class: "text-muted italic m-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Kho", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Người nhận", -1)
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Loại phiếu", -1)
const _hoisted_11 = { class: "mb-0 break-word truncate" }
const _hoisted_12 = { class: "mb-0 whitespace-nowrap" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "mb-0 text-right whitespace-nowrap font-bold" }
const _hoisted_15 = { class: "whitespace-nowrap m-0" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = {
  key: 0,
  class: "mb-0 text-muted text-xs"
}

import { formatAmount } from "@/core/helpers/number-format";
import {
  mapPhieuNhapXuatStatusToLabel,
  mapPhieuNhapXuatStatusToLevelColor,
  getDuyetPhieuNhapXuatStatus,
  swalNotification,
  swalErrNotification,
} from "@/core/helpers/utils";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { IPhieuXuatKhoResponseBase } from "@/core/interfaces/ApiResponses";
import { computed, PropType, ref } from "vue";

import ConfirmationDialog from "@/components/confirmation-dialog/ConfirmationDialog.vue";
import ConfirmHoanThanh from "@/components/shared/confirm-hoan-thanh-modal/ConfirmHoanThanh.vue";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import { usePagination } from "@/core/hooks/use-pagination";
import usePermission from "@/core/hooks/usePermission";
import usePhieuXuat from "@/core/hooks/usePhieuXuat";
import PhieuXuatKhoService from "@/core/services/Receipt.service";
import { useStore } from "vuex";
import { useLoading } from "@/core/hooks/use-loading";
import BaseLink from "@/components/shared/base-link/BaseLink.vue";
import IconCircleCheckClassicRegular from "@/icons/IconCircleCheckClassicRegular.vue";
import IconEye from "@/icons/IconEye.vue";
import IconMemoCircleCheckClassicSolid from "@/icons/IconMemoCircleCheckClassicSolid.vue";
import IconPencil from "@/icons/IconPencil.vue";
import IconPrint from "@/icons/IconPrint.vue";
import IconTrash from "@/icons/IconTrash.vue";
import { openPhieuXuatKhoPdf } from "@/components/shared/pdf-viewer/open-phieu-xuat-kho-pdf";
import { useRouter } from "vue-router";
import { LOAI_DINH_MUC_API } from "./constants";

interface PhieuXuatKhoTableAction {
  buttonType: string;
  colorType?: string;
  tooltipMessage: string;
  condition?: (row: IPhieuXuatKhoResponseBase) => boolean;
  isDisabled?: boolean | ((row: IPhieuXuatKhoResponseBase) => boolean);
  onClick: (row: IPhieuXuatKhoResponseBase) => void | Promise<unknown>;
  icon?: SettingAction["icon"];
  label?: string;
  tooltip?: string;
  any?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoTable',
  props: {
  curPage: {
    type: Number as PropType<number>,
    default: 1,
  },
  perPage: {
    type: Number as PropType<number>,
    default: 0,
  },
  showXacNhanButton: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  showDuyetButton: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  showXuatTaiKhoColumn: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  items: {
    type: Array as PropType<Array<IPhieuXuatKhoResponseBase>>,
    default: () => [],
  },
  /**
   * Custom action buttons array. If provided, these buttons will be used instead of default buttons.
   * Each button object should contain:
   * - buttonType: string - The button type from ButtonsType enum
   * - colorType: string - The color type from ButtonTypeColors enum
   * - tooltipMessage: string - Tooltip text for the button
   * - condition?: (row: any) => boolean - Optional condition function to show/hide button
   * - onClick: (row: any) => void - Click handler function
   * - icon?: string - Optional icon identifier
   */
  actionButtons: {
    type: Array as PropType<Array<PhieuXuatKhoTableAction>>,
    default: () => [],
  },
  showDuyetColumn: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  showLoaiDinhMucColumn: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ["refresh"],
  setup(__props, { emit: __emit }) {

const { formatDisplayingDate } = useDateTime();

const { push } = useRouterCustom();
const router = useRouter();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const { canDuyetPxk } = usePermission();

const { indexCal } = usePagination();

const props = __props;

const computedItems = computed(() => props.items);

const emit = __emit;

const { goToEditPhieuXuatLink, isPhieuXuatEditable } = usePhieuXuat();

const getLoaiPhieuXuatLink = (row: IPhieuXuatKhoResponseBase): string => {
  if (row.loai_phieu === 1 || row.loai_phieu === 2) {
    return `/quan-ly/phieu-xuat-kho/chi-tiet/${row.id}`;
  }

  return `/quan-ly/bien-ban-giai-the/chi-tiet/${row.id_bien_ban_giai_the}`;
};

const shouldShowDefaultButtons = computed(() => {
  return props.actionButtons.length === 0;
});

const defaultActionButtons = computed((): PhieuXuatKhoTableAction[] => {
  const buttons: PhieuXuatKhoTableAction[] = [];

  buttons.push({
    buttonType: ButtonsType.INFO,
    colorType: ButtonTypeColors.INFO,
    tooltipMessage: "Chi tiết phiếu xuất",
    label: "Chi tiết phiếu xuất",
    onClick: (row: IPhieuXuatKhoResponseBase) => {
      push(`/quan-ly/phieu-xuat-kho/chi-tiet/${row.id}`);
    },
  });

  buttons.push({
    buttonType: ButtonsType.EDIT,
    colorType: ButtonTypeColors.SUCCESS,
    tooltipMessage: "Chỉnh sửa phiếu xuất",
    label: "Chỉnh sửa phiếu xuất",
    condition: (row: IPhieuXuatKhoResponseBase) => isPhieuXuatEditable(row),
    onClick: (row: IPhieuXuatKhoResponseBase) => goToEditPhieuXuatLink(row),
  });

  buttons.push({
    buttonType: ButtonsType.PRINT,
    colorType: ButtonTypeColors.SECONDARY,
    tooltipMessage: "In phiếu",
    label: "In phiếu",
    onClick: (row: IPhieuXuatKhoResponseBase) =>
      openPhieuXuatKhoPdf(router, row.id),
  });

  buttons.push({
    buttonType: ButtonsType.TRASH,
    colorType: ButtonTypeColors.DANGER,
    tooltipMessage: "Xoá",
    label: "Xoá",
    any: ["data:pxk:xoa"],
    isDisabled: (row: IPhieuXuatKhoResponseBase) =>
      row.is_approved || row.hoan_thanh,
    onClick: (row: IPhieuXuatKhoResponseBase) =>
      onDeleteButtonCLickedHandler(row.id),
  });

  if (props.showXacNhanButton && canDuyetPxk.value) {
    buttons.push({
      buttonType: ButtonsType.CONFIRM,
      colorType: ButtonTypeColors.WARNING,
      tooltipMessage: "Xác nhận",
      label: "Xác nhận",
      any: ["data:pxk:duyet"],
      isDisabled: (row: IPhieuXuatKhoResponseBase) =>
        row.is_approved ||
        getDuyetPhieuNhapXuatStatus(row.processing_status).isDisabled,
      condition: (row: IPhieuXuatKhoResponseBase) =>
        getDuyetPhieuNhapXuatStatus(row.processing_status).isDisplay,
      onClick: (row: IPhieuXuatKhoResponseBase) => {
        confirmingApproval.value = row;
      },
    });
  }

  if (props.showDuyetButton) {
    buttons.push({
      buttonType: ButtonsType.APPROVE,
      colorType: ButtonTypeColors.SUCCESS,
      tooltipMessage: "Duyệt",
      label: "Duyệt",
      any: ["data:pxk:duyet"],
      isDisabled: (row: IPhieuXuatKhoResponseBase) =>
        row.is_approved ||
        getDuyetPhieuNhapXuatStatus(row.processing_status).isDisabled,
      onClick: (row: IPhieuXuatKhoResponseBase) => handleAdminSign(row),
    });
  }

  return buttons;
});

const getVisibleActionConfigs = (row: IPhieuXuatKhoResponseBase) => {
  const buttonsToUse = shouldShowDefaultButtons.value
    ? defaultActionButtons.value
    : props.actionButtons;

  return buttonsToUse.filter((button) => {
    if (button.condition) {
      return button.condition(row);
    }

    return true;
  });
};

const isActionDisabled = (
  button: PhieuXuatKhoTableAction,
  row: IPhieuXuatKhoResponseBase
): boolean => {
  if (typeof button.isDisabled === "function") {
    return button.isDisabled(row);
  }

  return button.isDisabled || false;
};

const getIconForButtonType = (buttonType: string) => {
  switch (buttonType) {
    case ButtonsType.EDIT:
      return IconPencil;
    case ButtonsType.TRASH:
      return IconTrash;
    case ButtonsType.PRINT:
      return IconPrint;
    case ButtonsType.APPROVE:
    case ButtonsType.DONE:
    case ButtonsType.CIRCLE_CHECK_CLASSIC_REGULAR:
      return IconCircleCheckClassicRegular;
    case ButtonsType.CONFIRM:
    case ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_LIGHT:
    case ButtonsType.MEMO_CIRCLE_CHECK_CLASSIC_SOLID:
      return IconMemoCircleCheckClassicSolid;
    case ButtonsType.INFO:
    case ButtonsType.EYE:
    case ButtonsType.DETAIL:
    default:
      return IconEye;
  }
};

const getVisibleSettingActions = (
  row: IPhieuXuatKhoResponseBase
): SettingAction[] => {
  return getVisibleActionConfigs(row).map((actionConfig) => ({
    icon: actionConfig.icon || getIconForButtonType(actionConfig.buttonType),
    label: actionConfig.label || actionConfig.tooltipMessage,
    tooltip: actionConfig.tooltip || actionConfig.tooltipMessage,
    any: actionConfig.any,
    isDisabled: isActionDisabled(actionConfig, row),
    onClick: () => {
      if (isActionDisabled(actionConfig, row)) {
        return;
      }

      return actionConfig.onClick(row);
    },
  }));
};

const deletingPhieuXuat = ref<null | IPhieuXuatKhoResponseBase>(null);

const onDeleteButtonCLickedHandler = (phieuXuatId: number) => {
  deletingPhieuXuat.value =
    props.items.find(({ id }) => id === phieuXuatId) ?? null;
};

const confirmingApproval = ref<null | IPhieuXuatKhoResponseBase>(null);
const approvingPhieuXuat = ref<null | IPhieuXuatKhoResponseBase>(null);

const onConfirmApprovalDialog = () => {
  if (confirmingApproval.value) {
    approvingPhieuXuat.value = confirmingApproval.value;
    confirmingApproval.value = null;
  }
};

const confirmApproval = () => {
  approvingPhieuXuat.value = null;
  emit("refresh");
};

const confirmDeleting = async () => {
  await PhieuXuatKhoService.delete(deletingPhieuXuat.value?.id || 0);

  deletingPhieuXuat.value = null;

  emit("refresh");
};

const { commit } = useStore();
const { endLoading, startLoading } = useLoading();

const handleAdminSign = (data: IPhieuXuatKhoResponseBase) => {
  commit("ConfirmationDialogModule/setDialog", {
    title: `Phiếu xuất số ${data.so_phieu}`,
    message: "Xác nhận duyệt phiếu xuất này?",
    onConfirm: async () => {
      commit("ConfirmationDialogModule/closeDialog");
      await startLoading();

      try {
        await PhieuXuatKhoService.adminSign(data.id);
        await endLoading();
        await swalNotification("Duyệt phiếu xuất thành công");
        emit("refresh");
      } catch (e) {
        await endLoading();
        await swalErrNotification(e, "Có lỗi xảy ra");
      }
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmHoanThanh, {
      for: 'phieu_xuat',
      "phieu-xuat-data": approvingPhieuXuat.value,
      show: !!approvingPhieuXuat.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (approvingPhieuXuat.value = null)),
      onConfirm: confirmApproval
    }, null, 8, ["phieu-xuat-data", "show"]),
    _createVNode(ConfirmationDialog, {
      title: `Phiếu xuất số ${deletingPhieuXuat.value?.so_phieu}`,
      "is-display": !!deletingPhieuXuat.value,
      width: "20%",
      onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (deletingPhieuXuat.value = null)),
      onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (deletingPhieuXuat.value = null)),
      onOnConfirmButtonClick: confirmDeleting
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["title", "is-display"]),
    _createVNode(ConfirmationDialog, {
      title: `Phiếu xuất số ${confirmingApproval.value?.so_phieu}`,
      "is-display": !!confirmingApproval.value,
      width: "20%",
      onOnCloseButtonClick: _cache[3] || (_cache[3] = ($event: any) => (confirmingApproval.value = null)),
      onOnCloseIconClick: _cache[4] || (_cache[4] = ($event: any) => (confirmingApproval.value = null)),
      onOnConfirmButtonClick: onConfirmApprovalDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("h5", _hoisted_2, [
          _createTextVNode(" Bạn có chắc chắn muốn phê duyệt phiếu xuất kho có số phiếu "),
          _createElementVNode("strong", null, _toDisplayString(confirmingApproval.value?.so_phieu), 1),
          _createTextVNode("? ")
        ])
      ]),
      _: 1
    }, 8, ["title", "is-display"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        "empty-text": "Không có dữ liệu",
        style: {"width":"100%"},
        size: "medium",
        "max-height": "800",
        border: true,
        data: computedItems.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "STT",
            "min-width": "60"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(`${_unref(indexCal)(scope.$index, __props.curPage, __props.perPage)}`), 1),
              (scope.row.id)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                    _createElementVNode("small", _hoisted_6, "(" + _toDisplayString(scope.row.id) + ")", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Số phiếu",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.so_phieu), 1)
            ]),
            _: 1
          }),
          (__props.showXuatTaiKhoColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                width: "250"
              }, {
                header: _withCtx(() => [
                  _hoisted_7
                ]),
                default: _withCtx((scope) => [
                  _createVNode(BaseLink, {
                    to: {
              name: 'chi-tiet-kho',
              params: {
                id: scope.row.kho.id,
              },
            }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.kho?.ten_kho ?? "-"), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, { "min-width": "150" }, {
            header: _withCtx(() => [
              _hoisted_8
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_9, _toDisplayString(scope.row.ten_nguoi_nhan ?? "-"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { width: "300" }, {
            header: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_11, [
                _createVNode(BaseLink, {
                  to: getLoaiPhieuXuatLink(scope.row),
                  "is-open-in-new-tab": ""
                }, {
                  default: _withCtx(() => [
                    (scope.row.loai_phieu === 1)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "info",
                          effect: "plain"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Xuất khác ")
                          ]),
                          _: 1
                        }))
                      : (scope.row.loai_phieu === 2)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "warning",
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" V/tư thu hồi ")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 2,
                            type: "success",
                            effect: "plain"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Xuất BBGT số " + _toDisplayString(scope.row.so_bien_ban), 1)
                            ]),
                            _: 2
                          }, 1024))
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 1
          }),
          (__props.showLoaiDinhMucColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                label: "Loại định mức",
                "min-width": "140"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("p", _hoisted_12, [
                    (scope.row.loai_dinh_muc === _unref(LOAI_DINH_MUC_API).DINH_MUC_CO_DINH)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Trong định mức ")
                          ]),
                          _: 1
                        }))
                      : (scope.row.loai_dinh_muc === _unref(LOAI_DINH_MUC_API).NGOAI_DINH_MUC)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Ngoài định mức ")
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.showDuyetColumn)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                label: "Duyệt",
                "min-width": "80"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: scope.row.is_approved,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.is_approved) = $event),
                    disabled: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: "Tổng tiền",
            "min-width": "150"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(formatAmount)(+scope.row.total_export_amount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Ngày H/thành",
            "min-width": "120"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ngay_hoan_thanh
              ? _unref(formatDisplayingDate)(scope.row.ngay_hoan_thanh)
              : "-"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Ngày tạo",
            "min-width": "120"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(scope.row.created_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Trạng thái",
            width: "150"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_15, [
                _createVNode(_component_el_button, {
                  type: 
                _unref(mapPhieuNhapXuatStatusToLevelColor)(scope.row.processing_status)
              ,
                  size: "mini"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(mapPhieuNhapXuatStatusToLabel)(scope.row.processing_status)), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Người tạo",
            "min-width": "140"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_16, _toDisplayString(scope.row.nguoi_dung?.ho_va_ten || "-"), 1),
              (scope.row.nguoi_dung?.so_dien_thoai)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(scope.row.nguoi_dung.so_dien_thoai), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            width: "50",
            fixed: "right",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(Setting, {
                actions: getVisibleSettingActions(scope.row)
              }, null, 8, ["actions"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ], 64))
}
}

})